module.exports = __webpack_public_path__ + "img/awards-1-s.07470dfc.png";